import { createAction, props } from "@ngrx/store";
import { IGameSummary } from "@soposopo/sopo-models";
import { GameStateId } from "../game/game.state";

export const addNewHistoryAction = createAction(
    'ADD_NEW_HISTORY_STATE',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const clearUnusedHistoriesAction = createAction(
    'CLEAR_UNUSED_HISTORY_STATES',
    props<{
        remainingGames: GameStateId[];
    }>()
)

export const displaySummary = createAction(
    'DISPLAY_SUMMARY',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const displayDetails = createAction(
    'DISPLAY_DETAILS',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const saveGameHistoryToStorage = createAction(
    '[]SAVE_HAND_HISTORY_TO_STORAGE',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const selectNextHandHistoryAction = createAction(
    '[GameHistorySelectorComponent] Next hand history selected',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const selectPreviousHandHistoryAction = createAction(
    '[GameHistorySelectorComponent] Previous hand history selected',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const resetHandHistoryCounter = createAction(
    '[GameHistorySelectorComponent] Reset hand history counter',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const receiveGameSummary = createAction(
    '[GameEffects$] Game Summary Received',
    props<{
        gameStateId: GameStateId;
        summary: IGameSummary;
        handId: string;
        events: any[];
        tableId: string;
    }>()
)
